import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import WorkplaceProviderCodeButton from './WorkplaceProviderCodeButton';

loadDOMComponent({
	selector: 'react-workplace-provider-code',
	callback: ({ container, context, props }: any) => {
		const workplaceId = container.getAttribute('workplaceId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<WorkplaceProviderCodeButton workplaceId={workplaceId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
